// noinspection DuplicatedCode

import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import Card from "@material-tailwind/react/Card";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { fetchPost, fetchPostSilance } from "../../../../fetchers";
import { useMutation } from "@tanstack/react-query";

import { isRequired, useForm } from "../../../../components/isRequired";
import { alertService } from "../../../../services/AlertService";

import Skeltons from "../../../../components/loading/Skeltons";
import { SearchBarSmallV2 } from "../../../../components/form/SearchBar";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { getMinKaryawan } from "../../karyawan/karyawanSlice";
import {
  // getTiketTransaksi,
  getTransaksiCodeTiket,
  // insertTiketTransaksi,
  tiketTransaksiSelector,
  updateTiketTransaksi,
} from "./tiketTransaksiSlice";
import { approve } from "../../../setup/approval/approvalSlice";

import { Colors } from "../../../../assets/Colors";
import { createNotification } from "../../../../components/notification/notification";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";

const PAGE_SIZE = 10;
const statusClass = (s) =>
  s === "Selesai"
    ? "text-green-600 font-medium"
    : s === "Ditolak" || s === "Revisi"
    ? "text-red-600 font-medium"
    : s === "Belum Dikirim"
    ? "text-gray-500 font-medium"
    : "text-yellow-600 font-medium";

const TiketPage = ({}) => {
  let initialState = {
    Nik: "",
    JenisTiket: -1,
    KeperluanTiket: "",
    JumlahKeberangkatan: -1,
    PergiDari: "",
    NamaArmada: "",
    PulangDari: "",
    Dewasa: "",
    Anak: "",
    Bayi: "",
    DasarPermohonan: -1,
  };

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    ({ JenisTiket }) =>
      isRequired(JenisTiket) || { JenisTiket: "Jenis tiket wajib diisi" },
    ({ KeperluanTiket }) =>
      isRequired(KeperluanTiket) || {
        KeperluanTiket: "Keperluan tiket wajib diisi",
      },
    ({ JumlahKeberangkatan }) =>
      isRequired(JumlahKeberangkatan) || {
        JumlahKeberangkatan: "Jumlah keberangkatan wajib diisi",
      },
    ({ PergiDari }) =>
      isRequired(PergiDari) || { PergiDari: "Pergi dari wajib diisi" },
    ({ NamaArmada }) =>
      isRequired(NamaArmada) || { NamaArmada: "Nama armada wajib diisi" },
    ({ JumlahKeberangkatan, PulangDari }) =>
      isRequired(PulangDari) || {
        PulangDari: "Pulang dari wajib diisi",
      },
    ({ Dewasa }) =>
      isRequired(Dewasa) || { Dewasa: "Jumlah orang dewasa wajib diisi" },
    ({ Anak }) => isRequired(Anak) || { Anak: "Jumlah anak-anak wajib diisi" },
    ({ Bayi }) => isRequired(Bayi) || { Bayi: "Jumlah bayi wajib diisi" },
    ({ DasarPermohonan }) =>
      isRequired(DasarPermohonan) || {
        DasarPermohonan: "Dasar permohonan wajib diisi",
      },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const mutation = useMutation((param) => fetchPost("getTiket", param));

  const mutationInput = useMutation((param) =>
    fetchPostSilance("insertTiket", param)
  );

  const dispatch = useDispatch();
  const [TanggalKeberangakatan, setTanggalKeberangakatan] = useState("");
  const [TanggalPulang, setTanggalPulang] = useState("");
  const [isValidTanggalKeberangakatan, setIsValidTanggalKeberangakatan] =
    useState(true);
  const [dateChanged, setDateChanged] = useState(false);
  const [isValidTanggalPulang, setIsValidTanggalPulang] = useState(true);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(5);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const tiket = useSelector(tiketTransaksiSelector);

  useEffect(() => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  }, []);

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      const initValues = {
        Nik: currentData.Nik,
        JenisTiket: currentData.JenisTiket,
        KeperluanTiket: currentData.KeperluanTiket,
        JumlahKeberangkatan: currentData.JumlahKeberangkatan,
        PergiDari: currentData.PergiDari,
        NamaArmada: currentData.NamaArmada,
        PulangDari: currentData.PulangDari,
        Dewasa: currentData.Dewasa,
        Anak: currentData.Anak,
        Bayi: currentData.Bayi,
        DasarPermohonan: currentData.DasarPermohonan,
      };

      dispatch(
        getTransaksiCodeTiket({
          Nik: currentData.Nik,
        })
      );

      editHandler(initValues);
      setTanggalKeberangakatan(new Date(currentData.TanggalKeberangakatan));
      setTanggalPulang(new Date(currentData.TanggalPulang));
    }
  });

  const reapprove = () => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  };

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  // ── Data list (client-side search + pagination) ─────────────
  const allRows = useMemo(() => {
    const d = mutation.data?.data;
    return Array.isArray(d) ? d : [];
  }, [mutation.data]);

  const filtered = useMemo(() => {
    const kw = search.trim().toLowerCase();
    if (!kw) return allRows;
    return allRows.filter((r) =>
      [r.TTiketID, r.NamaKaryawan, r.NamaArmada, r.JenisTiketKet, r.StatusKet].some(
        (v) => v && v.toString().toLowerCase().includes(kw)
      )
    );
  }, [allRows, search]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPage(1);
  }, [search, mutation.data]);

  // ── Export (mengikuti hasil filter/search) ───────────────────
  const exportHeader = ["ID", "Nama Karyawan", "Nama Armada", "Jenis Tiket", "Tanggal", "Status Approval"];
  const exportBody = () =>
    filtered.map((r) => [
      r.TTiketID || "", r.NamaKaryawan || "", r.NamaArmada || "", r.JenisTiketKet || "", r.TanggalMonitoring || "", r.StatusKet || "",
    ]);
  const handleDownloadExcel = () => {
    downloadExcel({ fileName: "Tiket", sheet: "data", tablePayload: { header: exportHeader, body: exportBody() } });
  };
  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(13);
    doc.text("Tiket", 14, 14);
    autoTable(doc, { head: [exportHeader], body: exportBody(), startY: 20, styles: { fontSize: 7 }, headStyles: { fillColor: [30, 58, 95] } });
    doc.save("Tiket.pdf");
  };

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);

    dispatch(getMinKaryawan({ search: "" }));
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {mutation.isLoading ? (
                  <div className="w-full pt-0"><Skeltons /></div>
                ) : (
                  <>
                    <div className="flex w-full justify-between px-4 pt-4 flex-col sm:flex-row gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={() => handleModal({ showModalAdd: true, showModalEdit: false })}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                        >
                          Tambah +
                        </button>
                        <button onClick={handleDownloadExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
                          Download Excel
                        </button>
                        <button onClick={handleDownloadPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow">
                          Download PDF
                        </button>
                      </div>
                      <div className="w-full sm:w-72">
                        <SearchBarSmallV2 text={"Cari Tiket"} value={search} funcs={(e) => setSearch(e.target.value)} />
                      </div>
                    </div>

                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {["ID", "Nama Karyawan", "Nama Armada", "Jenis Tiket", "Tanggal", "Status Approval", "Actions"].map((h, i) => (
                              <th key={i} scope="col" className="py-3 px-6">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr><td colSpan={7} className="text-center py-8 text-gray-400">
                              {search ? `Tidak ada data untuk "${search}"` : "Tidak ada data"}
                            </td></tr>
                          ) : (
                            pageRows.map((row, id) => (
                              <tr key={row.TTiketID || id} className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                                <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.TTiketID}</td>
                                <td className="py-4 px-6">{row.NamaKaryawan || "-"}</td>
                                <td className="py-4 px-6">{row.NamaArmada || "-"}</td>
                                <td className="py-4 px-6">{row.JenisTiketKet || "-"}</td>
                                <td className="py-4 px-6 whitespace-nowrap text-xs">{row.TanggalMonitoring || "-"}</td>
                                <td className="py-4 px-6"><span className={statusClass(row.StatusKet)}>{row.StatusKet || "-"}</span></td>
                                <td className="py-4 px-6 whitespace-nowrap">
                                  {["-1", "-2", "-3"].includes(row.Status) && (
                                    <>
                                      <button
                                        onClick={() => { handleModal({ showModalAdd: false, showModalEdit: true }); handleCurrentData(row); }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2 mr-2"
                                      >
                                        Edit
                                      </button>
                                      <button
                                        onClick={() => { try { reapprove(); } catch (error) {} dispatch(approve({ primary: row.TTiketID })); }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2"
                                      >
                                        Kirim
                                      </button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filtered.length} data</span>
                      <div className="flex items-center gap-4">
                        <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev</button>
                        <span>Page {safePage} / {totalPage}</span>
                        <button onClick={() => setPage((p) => Math.min(totalPage, p + 1))} disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next</button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Nama Armada *
                </label>
                <input
                  value={values.NamaArmada}
                  onChange={changeHandler}
                  name="NamaArmada"
                  className={
                    (touched.NamaArmada || buttonTouched) && errors.NamaArmada
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.NamaArmada || buttonTouched) && errors.NamaArmada && (
                  <p className="text-red-500 text-xs italic">
                    {errors.NamaArmada}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Tiket *
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.JenisTiket}
                    onChange={changeHandler}
                    name="JenisTiket"
                    // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    className={
                      (touched.JenisTiket || buttonTouched) && errors.JenisTiket
                        ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option defaultValue disabled value={-1} hidden>
                      -- Pilih Data --
                    </option>
                    <option value={1}>Darat</option>
                    <option value={2}>Laut</option>
                    <option value={3}>Udara</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                  {(touched.JenisTiket || buttonTouched) &&
                    errors.JenisTiket && (
                      <p className="text-red-500 text-xs italic">
                        {errors.JenisTiket}
                      </p>
                    )}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jumlah Keberangkatan *
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.JumlahKeberangkatan}
                    onChange={changeHandler}
                    name="JumlahKeberangkatan"
                    // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    className={
                      (touched.JumlahKeberangkatan || buttonTouched) &&
                      errors.JumlahKeberangkatan
                        ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option defaultValue disabled value={-1} hidden>
                      -- Pilih Data --
                    </option>
                    <option value={1}>Sekali Terbang</option>
                    <option value={2}>Pulang Balik</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                  {(touched.JumlahKeberangkatan || buttonTouched) &&
                    errors.JumlahKeberangkatan && (
                      <p className="text-red-500 text-xs italic">
                        {errors.JumlahKeberangkatan}
                      </p>
                    )}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Dari *
                </label>
                <input
                  value={values.PergiDari}
                  onChange={changeHandler}
                  name="PergiDari"
                  className={
                    (touched.PergiDari || buttonTouched) && errors.PergiDari
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.PergiDari || buttonTouched) && errors.PergiDari && (
                  <p className="text-red-500 text-xs italic">
                    {errors.PergiDari}
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tujuan *
                </label>
                <input
                  value={values.PulangDari}
                  onChange={changeHandler}
                  name="PulangDari"
                  className={
                    (touched.PulangDari || buttonTouched) && errors.PulangDari
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.PulangDari || buttonTouched) && errors.PulangDari && (
                  <p className="text-red-500 text-xs italic">
                    {errors.PulangDari}
                  </p>
                )}
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Keperluan Tiket *
                </label>
                <input
                  value={values.KeperluanTiket}
                  onChange={changeHandler}
                  name="KeperluanTiket"
                  className={
                    (touched.KeperluanTiket || buttonTouched) &&
                    errors.KeperluanTiket
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.KeperluanTiket || buttonTouched) &&
                  errors.KeperluanTiket && (
                    <p className="text-red-500 text-xs italic">
                      {errors.KeperluanTiket}
                    </p>
                  )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Dasar Permohonan
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.DasarPermohonan}
                    onChange={changeHandler}
                    name="DasarPermohonan"
                    // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    className={
                      "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option defaultValue disabled value={-1} hidden>
                      -- Pilih Data --
                    </option>
                    <option value={1}>Cuti</option>
                    <option value={2}>Perjalanan Dinas</option>
                    <option value={3}>Training</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
                {(touched.DasarPermohonan || buttonTouched) &&
                  errors.DasarPermohonan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.DasarPermohonan}
                    </p>
                  )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Keberangakatan *
                </label>
                <DatePicker
                  className={
                    !isValidTanggalKeberangakatan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  selected={TanggalKeberangakatan}
                  onChange={(date) => {
                    setTanggalKeberangakatan(date);
                    setTanggalPulang("");
                    setIsValidTanggalKeberangakatan(true);
                    setIsValidTanggalPulang(false);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalKeberangakatan && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal keberangkatan wajib diisi
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Akhir *
                </label>
                <DatePicker
                  className={
                    !isValidTanggalPulang
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  disabled={TanggalKeberangakatan === ""}
                  minDate={new Date(TanggalKeberangakatan).setDate(
                    new Date(TanggalKeberangakatan).getDate()
                  )}
                  selected={TanggalPulang}
                  onChange={(date) => {
                    setTanggalPulang(date);
                    setIsValidTanggalPulang(true);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalPulang && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal pulang wajib diisi
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Dewasa
                </label>
                <div className="inline-block relative w-full  ">
                  <input
                    value={values.Dewasa}
                    onChange={changeHandler}
                    name="Dewasa"
                    className={
                      (touched.Dewasa || buttonTouched) && errors.Dewasa
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.Dewasa || buttonTouched) && errors.Dewasa && (
                    <p className="text-red-500 text-xs italic">
                      {errors.Dewasa}
                    </p>
                  )}
                </div>
              </div>
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Anak
                </label>
                <div className="inline-block relative w-full  ">
                  <input
                    value={values.Anak}
                    onChange={changeHandler}
                    name="Anak"
                    className={
                      (touched.Anak || buttonTouched) && errors.Anak
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.Anak || buttonTouched) && errors.Anak && (
                    <p className="text-red-500 text-xs italic">{errors.Anak}</p>
                  )}
                </div>
              </div>
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Bayi
                </label>
                <div className="inline-block relative w-full  ">
                  <input
                    value={values.Bayi}
                    onChange={changeHandler}
                    name="Bayi"
                    className={
                      (touched.Bayi || buttonTouched) && errors.Bayi
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.Bayi || buttonTouched) && errors.Bayi && (
                    <p className="text-red-500 text-xs italic">{errors.Bayi}</p>
                  )}
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              (isValid || (showModalEdit && dateChanged && !isValid)) &&
              isValidTanggalKeberangakatan &&
              isValidTanggalPulang
                ? "green"
                : "blueGray"
            }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              if (TanggalKeberangakatan === "") {
                setIsValidTanggalKeberangakatan(false);
              }
              if (TanggalPulang === "") {
                setIsValidTanggalPulang(false);
              }
              let tempIsValid = isValid;
              if (showModalEdit && dateChanged && !isValid) {
                tempIsValid = true;
              }
              if (
                tempIsValid &&
                isValidTanggalKeberangakatan &&
                isValidTanggalPulang
              ) {
                const tanggal = {
                  TanggalKeberangakatan: JSON.stringify(TanggalKeberangakatan),
                  TanggalPulang: JSON.stringify(TanggalPulang),
                  TTiketID: currentData.TTiketID,
                };
                let code = null;
                if (currentData.DasarPermohonan === 1) {
                  if (tiket.dataTransaksiCodeTiket.Cuti === null) {
                    code = "";
                  } else {
                    code = tiket.dataTransaksiCodeTiket.Cuti[0];
                  }
                }
                if (currentData.DasarPermohonan === 2) {
                  if (tiket.dataTransaksiCodeTiket.PerjalananDinas === null) {
                    code = "";
                  } else {
                    code = tiket.dataTransaksiCodeTiket.PerjalananDinas[0];
                  }
                }
                if (currentData.DasarPermohonan === 3) {
                  if (tiket.dataTransaksiCodeTiket.Training === null) {
                    code = "";
                  } else {
                    code = tiket.dataTransaksiCodeTiket.Training[0];
                  }
                }

                const transCode = {
                  NomorTransaksi: "dsadasd",
                };
                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  createNotification("Berhasil mengubah data", "success");

                  dispatch(
                    updateTiketTransaksi(
                      Object.assign(values, tanggal, transCode)
                    )
                  );
                  reapprove();
                } else {
                  let tempdata = values
                  console.log(code)
                  tempdata["DasarPermohonan"] = parseInt(tempdata["DasarPermohonan"])
                  mutationInput.mutate(
                    Object.assign(values, tanggal, transCode),
                    {
                      onSuccess: async (data, context) => {
                        toast.success(data.message, {
                          position: "bottom-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: false,
                          draggable: true,
                          progress: undefined,
                          theme: "light",
                        });
                        setShowModalAdd(false);
                        setShowModalEdit(false);
                        reapprove();
                      },
                      onError: async (data, context) => {
                        toast.error(data.message, {
                          position: "bottom-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: false,
                          draggable: true,
                          progress: undefined,
                          theme: "light",
                        });
                      },
                    }
                  );
                }
              }
            }}
            ripple={
              isValid && isValidTanggalKeberangakatan && isValidTanggalPulang
                ? "light"
                : ""
            }
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default TiketPage;
